import React from "react";
import "./Csoon.scss";
import Comingsoon from "../../Media/Bellefont_Desktop.webp";
import Soon from "../../Media/Bellefont_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20(Promo%20Bellefont%20East)%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="promobellefont" className="container-bellefont">
      <div className="bellefont">
        <h1>New Launching Summarecon Serpong</h1>
        <h2>Bellefont East</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-Desktop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
          <p className="soon-disclaimer">
            Informasi properti harga, spesifikasi, dan ketersediaan unit dapat
            berubah sewaktu-waktu, silahkan hubungi kamu untuk informasi terbaru
          </p>
        </div>
      </div>
    </div>
  );
};

export default soon;
